//3rd Party Components
import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";

const ProfileTile = ({ name, role, arn, type, link, messages, attributeOptions }) => {
    let history = useHistory();

    const msgs = (messages) => {
        return (
            messages.map((item, index) => {
                return (
                    item.msg.level === "warning" ?
                        <span key={index} className="badge badge-warning">{item.msg.message}</span>
                        :
                        item.msg.level === "success" ?
                            <span key={index} className="badge badge-success">{item.msg.message}</span>
                            :
                            <span key={index}>{item.msg.message}</span>
                );
            })
        )
    }

    const handleClick = (link, e) => {
        e.preventDefault();
        history.push(link);
    }

    const setClass = (profileType) => {
        if (profileType === "Individual") {
            return ("casa-profile-select casa-profile-individual")
        }
        else {
            return ("casa-profile-select casa-profile-organisation")
        }
    }

    return (
        <div className={setClass(type)} onClick={(e) => handleClick(link, e)} {...attributeOptions}>                
            <h2 className="au-display-lg">
                <Link to={link}>{name}</Link>
            </h2>
            <div>{type} account<br /></div>		  		
            {role !== "" ? <div>Role: {role} <br /></div> : ""}
            {arn !== "" ? <div>ARN: {arn} {messages ? msgs(messages) : ""} </div> : ""}
                        
        </div>
    );
};

//add defaults

ProfileTile.propTypes = {
    name: PropTypes.string,
    role: PropTypes.string,
    arn: PropTypes.string,
    type: PropTypes.oneOf(['Individual', 'Organisation']),
    messages: PropTypes.array,
    attributeOptions: PropTypes.object,
    link: PropTypes.string
};

export default ProfileTile;
